<template>
  <file-upload
    ref="upload"
    v-model="files"
    class="edit-avatar-icon"
    :class="{ 'edit-avatar-icon': profile }"
    extensions="gif,jpg,jpeg,png,webp"
    accept="image/png, image/gif, image/jpeg, image/webp"
    :post-action="postPath"
    :multiple="false"
    :drop="false"
    :drop-directory="false"
    :headers="headers"
    :chunk-enabled="chunk"
    :chunk="{
      maxActive,
      maxRetries,
    }"
    @input-file="inputFile"
    @input-filter="inputFilter"
  >
    <b-button
      class="icon-primary"
      :class="{
        'icon-light d-flex justify-content-between align-items-center h-100 block': profile,
        'px-0': !profile,
      }"
      :variant="profile ? 'primary' : 'transparent'"
    >
      <svg-icon name="edit3" :stroke="profile ? 'white' : ''" size="24"></svg-icon>
    </b-button>
  </file-upload>
</template>

<script>
export default {
  name: 'SmartOeePhotoUpload',
  props: {
    profile: Boolean,
  },
  data: () => {
    return {
      imageFormats: ['jpg', 'jpeg', 'png'],
      files: [],
      chunk: true,
      maxActive: 1,
      maxRetries: 10,
      headers: {
        'Upload-Type': 'single',
      },
    };
  },
  computed: {
    uploaded() {
      return (
        this.files.every((f) => f.response && f.response.fileName) ||
        (this.$refs.upload && this.$refs.upload.uploaded)
      );
    },
    postPath() {
      // eslint-disable-next-line no-undef
      return myConfig.GrapgQlUrl + 'upload';
    },
  },

  watch: {
    uploaded(value) {
      if (this.files && this.files.length && value) {
        this.$emit('uploaded', {
          fileName: this.files[0].name,
          filePath: this.files[0].response.fileName,
        });
      }
    },
  },

  methods: {
    inputFile() {
      this.$refs.upload.active = true;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|js?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = '';
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.file-uploads.file-uploads-html5 {
  &::v-deep label {
    cursor: pointer;
  }
}
.edit-avatar-icon {
  height: 48px;
  width: 48px;
  border: none;
}
</style>
